import merge from 'lodash/merge';
import { baseTheme, updateTheme } from './index';
import { flattenTheme } from './utils';
import gomoTheme from './advance/index';
import { remCalc } from '@lux/helpers';
import { withOpacity } from '../helpers';
var advanceThemeProps = merge({}, baseTheme, {
  main: {
    fontFamily: {
      primaryThin: "Poppins-Bold, arial, helvetica, sans-serif",
      primaryRegular: "Poppins-Bold, arial, helvetica, sans-serif",
      primaryBold: "Poppins-Bold, arial, helvetica, sans-serif",
      secondaryThin: "Roboto, arial, helvetica, sans-serif",
      secondaryRegular: "Roboto-Bold, arial, helvetica, sans-serif",
      secondaryBold: "Roboto-Bold, arial, helvetica, sans-serif"
    },
    colours: {
      primary: {
        d1: gomoTheme.colours.gomo_cerise,
        d2: gomoTheme.colours.gomo_cerise,
        d3: gomoTheme.colours.gomo_cerise,
        d4: gomoTheme.colours.gomo_cerise_fc
      },
      secondary: {
        l1: gomoTheme.colours.gomo_cerise,
        l2: gomoTheme.colours.gomo_cerise,
        d1: gomoTheme.colours.gomo_grey_e6,
        d2: gomoTheme.colours.gomo_grey_be,
        d3: gomoTheme.colours.gomo_grey_bb
      },
      tertiary: {
        l3: gomoTheme.colours.gomo_cyan,
        l4: gomoTheme.colours.gomo_ocean_blue
      }
    },
    shadows: {
      size1: '0 2.5px 5px 0 rgba(18,18,18,0.2)',
      size2: '0 8px 12px 0 rgba(18,18,18,0.2)'
    }
  }
});
export var getAdvanceTheme = function getAdvanceTheme(theme) {
  var flatTheme = flattenTheme(updateTheme(advanceThemeProps, theme));
  var advanceComponentsProps = {
    text: {
      header: {
        fontFamily: flatTheme.ff_pri_bold
      },
      body: {
        letterSpacing: '0px'
      },
      boldBody: {
        letterSpacing: 0.3
      },
      smallBody: {
        letterSpacing: '0px'
      }
    },
    button: {
      background: flatTheme.cl_pri_base,
      hoverBg: flatTheme.cl_pri_d2,
      activeBg: flatTheme.cl_pri_d4,
      border: "1px solid transparent",
      borderRadius: "".concat(remCalc(20)),
      padding: "0 ".concat(remCalc(20)),
      mdPadding: "0 ".concat(remCalc(40)),
      minWidth: remCalc(180),
      maxHeight: remCalc(40),
      minHeight: remCalc(40),
      fontSize: flatTheme.fs_md,
      fontWeight: 600,
      fontFamily: flatTheme.ff_pri_regular,
      secondary: {
        color: flatTheme.cl_sec_d1,
        background: flatTheme.cl_sec_l2,
        borderColor: 'transparent',
        hoverBg: flatTheme.cl_sec_l1,
        activeBg: flatTheme.cl_sec_base
      },
      customStyle: {}
    },
    tab: {
      tabBarDividerPositionBottom: '15px',
      tabBarContainerPaddingBottom: '15px',
      tabItemContainerPadding: '14px',
      selectedTabTitleColor: flatTheme.cl_sec_d1,
      tabTitleColor: flatTheme.cl_ter_base,
      tabItemContainerHoverBg: withOpacity(flatTheme.cl_sec_l1, 0.8),
      tabItemContainerActiveBg: withOpacity(flatTheme.cl_white, 0.5),
      tabItemContainerBg: flatTheme.cl_white,
      tabItemIndicatorBgColor: flatTheme.cl_sec_d1,
      tabBarDividerBgColor: flatTheme.cl_ter_l5,
      bottomBorderColor: flatTheme.cl_ter_l5
    },
    pagination: {
      fontSize: '0.875rem',
      marginTop: '16px',
      button: {
        fontFamily: flatTheme.ff_sec_regular,
        color: flatTheme.cl_ter_l2,
        backgroundColor: 'transparent',
        hoverBg: flatTheme.cl_sec_l2,
        borderRadius: '16px',
        height: '32px',
        minWidth: '32px',
        margin: '0 3px',
        padding: '0 6px',
        selected: {
          color: flatTheme.cl_white,
          backgroundColor: flatTheme.cl_sec_d1
        },
        svg: {
          width: '16px',
          height: '16px'
        }
      }
    },
    header: {
      desktopHeight: '72px',
      mobileHeight: '64px',
      desktopMenuActiveFontColor: flatTheme.cl_ter_l4,
      desktopMenuInActiveFontColor: flatTheme.cl_black,
      deskTopLogoHeight: '48px',
      logoAlignment: 'center',
      desktopSubMenuFontColor: flatTheme.cl_ter_base,
      desktopSubMenuActiveFontColor: flatTheme.cl_ter_l4,
      desktopSubMenuFontSize: flatTheme.fs_md,
      mobileMenuFontColor: flatTheme.cl_ter_base,
      mobileMenuActiveFontColor: flatTheme.cl_ter_l4
    },
    footer: {
      backgroundColor: flatTheme.cl_ter_l6,
      linkFont: flatTheme.ff_sec_regular,
      linkFontColor: flatTheme.cl_ter_l4,
      linkFontSize: flatTheme.fs_md
    }
  };
  return Object.assign({}, flatTheme, advanceComponentsProps);
};
export var advanceTheme = getAdvanceTheme();
export default advanceTheme;